














import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
})
export default class RateSelector extends Vue {
  @Prop(Boolean) isReadonly: false;
  @Prop(Number) rating: 0;

  hoveredNumber: number = 0;

  /*
    If a rating prop is defined, we apply the value in this.hoveredNumber,
    meaning we preselect a rating in the template
  */
  @Watch('rating', { immediate: true })
  initHoveredNumber (val: number) {
    this.hoveredNumber = val;
  }
}
